const CLAIM_TYPE_DESCRIPTION_PREFIX = 'fastCover.claimTypeDescription.';

export const normalizeClaimTypeDescriptionKey = (value = '') => value
  .replace(/&/g, ' and ')
  .replace(/[^A-Za-z0-9]+/g, ' ')
  .trim()
  .split(' ')
  .filter((word) => word.length > 0)
  .map((word, index) => {
    const lower = word.toLowerCase();
    return index === 0 ? lower : lower.charAt(0).toUpperCase() + lower.slice(1);
  })
  .join('');

export const getClaimTypeDescriptionMessageId = (description = '') => {
  const key = normalizeClaimTypeDescriptionKey(description);
  return key ? `${CLAIM_TYPE_DESCRIPTION_PREFIX}${key}` : null;
};

export const formatClaimTypeDescription = (intl, description = '') => {
  const messageId = getClaimTypeDescriptionMessageId(description);
  if (!messageId || !intl || typeof intl.formatMessage !== 'function') {
    return description;
  }

  return intl.formatMessage({ id: messageId, defaultMessage: description });
};

export const formatClaimTypeDocumentsHeader = (intl, description = '') => {
  const claimTypeDescription = formatClaimTypeDescription(intl, description);
  if (!intl || typeof intl.formatMessage !== 'function') {
    return `${claimTypeDescription} documents`;
  }

  return intl.formatMessage(
    {
      id: 'fastCover.stepSupportingDocuments.claimTypeDocumentsHeader',
      defaultMessage: '{claimTypeDescription} documents',
    },
    { claimTypeDescription }
  );
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/utils/claimTypeDescriptionLocalization.js